// extracted by mini-css-extract-plugin
module.exports = {"main-component":"team_main-component__20X8R"};